/**
 * Thin PostHog wrapper. The library is bootstrapped in public/index.html
 * with a stub `window.posthog` so calls made before the async script loads
 * are queued transparently. All events go through here so we get:
 *  - one place to disable analytics for tests
 *  - guaranteed no-op when posthog isn't present (SSR / preview envs)
 *  - stable event names (magic strings live here, not in every page)
 *  - automatic enrichment with a referral score band if the user landed
 *    via a `?score=X` share link (see /lib/referral.js).
 */
import { withReferral } from "./referral";

export const EVENTS = {
  HOME_VIEW: "centennial_home_view",
  CALCULATOR_RUN: "calculator_run",
  BOOK_CLICK: "book_click",
  BOOK_PURCHASE_OUTBOUND: "book_purchase_outbound",
  EBOOK_WAITLIST_JOIN: "ebook_waitlist_join",
  AUTHOR_SUBMISSION: "author_submission",
};

export function track(event, props) {
  try {
    if (typeof window !== "undefined" && window.posthog?.capture) {
      window.posthog.capture(event, withReferral(props || {}));
    }
  } catch {
    /* analytics must never break the app */
  }
}
